import { render, staticRenderFns } from "./PrepareRecommend.vue?vue&type=template&id=4fc1fe37&scoped=true&"
import script from "./PrepareRecommend.vue?vue&type=script&lang=js&"
export * from "./PrepareRecommend.vue?vue&type=script&lang=js&"
import style0 from "./PrepareRecommend.vue?vue&type=style&index=0&id=4fc1fe37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc1fe37",
  null
  
)

export default component.exports